import { z } from 'zod';
/** The most a token claim can state: one crore rupees, in paise. */
export const MAX_CLAIM_PAISE = 1_000_000_000;
export const CLAIM_PHOTO_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export const CLAIM_PHOTO_MAX_BYTES = 5 * 1024 * 1024;
export const STATUS_PARTIES = ['tenant', 'owner'];
export const statusPartySchema = z.enum(STATUS_PARTIES);
/** What the tenant says they paid. The screenshot key is one the API issued for this link. */
export const tokenClaimSchema = z.object({
    amountPaise: z.number().int().min(100).max(MAX_CLAIM_PAISE),
    upiReference: z
        .string()
        .trim()
        .regex(/^[A-Za-z0-9]{6,40}$/),
    screenshotKey: z.string().min(10).max(300).optional(),
});
export const claimUploadSchema = z.object({ contentType: z.enum(CLAIM_PHOTO_TYPES) });
/** The owner's answer, asked for before the code is sent. The code then confirms this answer. */
export const ownerAnswerRequestSchema = z.object({
    answer: z.enum(['received', 'not_received']),
    note: z.string().trim().max(500).optional(),
});
export const reopenClaimSchema = z.object({ reason: z.string().trim().min(5).max(500) });
//# sourceMappingURL=status.js.map